<template>
  <q-item class="q-mb-sm">
    <q-item-section>
      <q-item-label
        ><slot>{{ label || "k.A." }}</slot></q-item-label
      >
      <q-item-label v-if="caption" caption>{{ caption }}</q-item-label>
    </q-item-section>
  </q-item>
</template>

<script setup>
defineProps({
  label: { type: [String, Number], required: false },
  caption: { type: String, required: false },
});
</script>
